import { isEqual } from 'lodash';
import { useEffect, useRef, useState } from 'react';

export const useCaseBorderHighlight = (
  updatedFields: string[] | undefined,
  isNewOnBoard: boolean,
  ms = 5000,
): boolean => {
  const [showHighlight, setShowHighlight] = useState(false);
  const prevFieldsRef = useRef<string[]>([]);
  const hasTriggeredNew = useRef(false);

  useEffect(() => {
    const isFieldChanged = !isEqual(
      updatedFields ?? [],
      prevFieldsRef.current ?? [],
    );
    const shouldTrigger =
      (!hasTriggeredNew.current && isNewOnBoard) || isFieldChanged;

    if (shouldTrigger) {
      setTimeout(() => {
        setShowHighlight(true);
      }, 0);
      prevFieldsRef.current = updatedFields ?? [];
      hasTriggeredNew.current = true;

      const timeout = setTimeout(() => {
        setShowHighlight(false);
      }, ms);

      return () => clearTimeout(timeout);
    }
  }, [updatedFields, isNewOnBoard, ms]);

  return showHighlight;
};
